import { AffinityClient } from "../services/ohl.virtualCenter.api";

const apiClient = new AffinityClient(process.env.REACT_APP_PUBLIC_API);

let affinitiesCache = {};  
let affinitiesPromiseCache = {}; 
class AffinitiesProvider {

    GetAffinityForUser = ({ clientId }) => {
        if (affinitiesCache[clientId]) {
            return Promise.resolve(affinitiesCache[clientId]);
        }
        
        if (affinitiesPromiseCache[clientId]) {
            return affinitiesPromiseCache[clientId];
        }
    
        affinitiesPromiseCache[clientId] = new Promise((resolve, reject) => {
            apiClient.affinityForUser(clientId)
            .then(res => {
                affinitiesCache[clientId] = res;
                delete affinitiesPromiseCache[clientId]; // Limpiamos la promesa en curso
                resolve(res);
            })
            .catch(err => {
                delete affinitiesPromiseCache[clientId]; // Limpiamos la promesa en caso de error
                reject(err);
            });
        });
    
        return affinitiesPromiseCache[clientId];
    };
};

export default new AffinitiesProvider();